module.exports = "/ui/fonts/revicons.eot";